import { render, staticRenderFns } from "./svgSnappshop.vue?vue&type=template&id=5b39eb08"
import script from "./svgSnappshop.vue?vue&type=script&lang=js"
export * from "./svgSnappshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports